import { render } from "./ErrorPanel.vue?vue&type=template&id=9566fac0&scoped=true"
import script from "./ErrorPanel.vue?vue&type=script&lang=js"
export * from "./ErrorPanel.vue?vue&type=script&lang=js"

import "./ErrorPanel.vue?vue&type=style&index=0&id=9566fac0&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9566fac0"]])

export default __exports__